<div class="flex flex-col flex-auto items-center sm:justify-center min-w-0 md:p-8">
    <div class="flex md:w-full md:max-w-6xl sm:rounded-2xl sm:shadow overflow-hidden sm:bg-card sm:min-h-[950px]">
        <div class="w-full sm:w-auto py-8 px-4 sm:p-12 md:p-16">
            <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">

                <!-- Separator -->
                <div class="flex items-center mb-8">
                    <div class="flex-auto mt-px border-t"></div>
                    <div class="row">
                        <div class="col-sm-4 text-right">
                            <!-- Language -->
                            <languages></languages>
                        </div>
                    </div>
                    <div class="flex-auto mt-px border-t"></div>
                </div>

                <!-- Logo -->
                <div class="flex flex-col items-stretch mt-5 space-y-3 mb-8" [@zoomIn]="'true'">
                    <div class="flex flex-row gap-4 justify-center">
                        <div *ngIf="confirmationDto?.clinicLogo" class="sm:flex sm:flex-col items-center p-2 bg-card shadow-md w-50 rounded-md">
                            <img class="rounded-md" src="{{'data:image/jpg;base64,' + confirmationDto?.clinicLogo}}"/>
                        </div>

                        <div class="sm:flex sm:flex-col place-content-between p-2 bg-card shadow-md w-50 rounded-md">
                            <div class="p-2 bg-gradient-to-bl from-transparent from-0% dark:via-primary-900 via-primary-100 via-40% rounded-md">
                                <img class="rounded-md w-full mb-5" src="/assets/images/logo/logo.svg">
                            </div>

                        </div>
                    </div>

                    <div  *ngIf="confirmationDto?.clinicLogo"
                          class="sm:flex flex-row w-fit justify-center gap-2 fixed right-1/2 translate-x-1/2 bottom-2 bg-card shadow-xl p-1 px-4 rounded-xl content-center">
                        <div class="text-xs text-secondary font-medium tracking-tight leading-6 truncate text-center">powerd by</div>
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-small-right'"></mat-icon>
                    </div>
                </div>

                <!-- Alert -->
                <fuse-alert
                    class="mt-8 -mb-4"
                    *ngIf="showAlert"
                    [dismissible]="true"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'">
                    {{alert.message}}
                </fuse-alert>

                <ng-container [ngSwitch]="state">
                    <ng-container *ngSwitchCase="ConfirmationState.MISSING_CODE" [ngTemplateOutlet]="missingCode"></ng-container>
                    <ng-container *ngSwitchCase="ConfirmationState.LOADING" [ngTemplateOutlet]="loading"></ng-container>
                    <ng-container *ngSwitchCase="ConfirmationState.LOADED" [ngTemplateOutlet]="loaded"></ng-container>
                    <ng-container *ngSwitchCase="ConfirmationState.EXPIRED_INVALID_CODE" [ngTemplateOutlet]="expired_invalid"></ng-container>
                    <ng-container *ngSwitchCase="ConfirmationState.CONFIRMED" [ngTemplateOutlet]="confirmed"></ng-container>
                    <ng-container *ngSwitchCase="ConfirmationState.DECLINED" [ngTemplateOutlet]="declined"></ng-container>
                </ng-container>

            </div>
        </div>
        <div
            class="relative hidden md:flex flex-auto items-center justify-center h-full p-16 lg:px-28 overflow-hidden bg-image"
            style="background-image: url('assets/images/ui/smm/bgLogIn2.jpg'); background-position: center;">

            <div class="ai-container">
                <div class="particles">
                    <div class="particle p1" style="--angle: 30deg"></div>
                    <div class="particle p2" style="--angle: 60deg"></div>
                    <div class="particle p3" style="--angle: 90deg"></div>
                    <div class="particle p4" style="--angle: 120deg"></div>
                    <div class="particle p5" style="--angle: 150deg"></div>
                    <div class="particle p6" style="--angle: 180deg"></div>
                    <div class="particle p7" style="--angle: 210deg"></div>
                    <div class="particle p8" style="--angle: 240deg"></div>
                    <div class="particle p9" style="--angle: 270deg"></div>
                    <div class="particle p10" style="--angle: 300deg"></div>
                    <div class="particle p11" style="--angle: 330deg"></div>
                    <div class="particle p12" style="--angle: 360deg"></div>
                </div>
                <div class="ring ring-1"></div>
                <div class="ring ring-2"></div>
                <div class="ring ring-3"></div>
                <div class="core">
                    <img src="assets/images/logo/logo.svg" alt="singura-logo" class="mt-6 scale-[0.8]">
                </div>
                <div class="shockwave"></div>
            </div>

            <!-- Background - @formatter:off -->
            <!-- Rings -->
            <svg class="absolute inset-0 pointer-events-none"
                 viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
                <g class="text-gray-700 opacity-25" fill="none" stroke="currentColor" stroke-width="100">
                    <circle r="234" cx="196" cy="23"></circle>
                    <circle r="234" cx="790" cy="491"></circle>
                </g>
            </svg>
            <!-- Dots -->
            <svg class="absolute -top-16 -right-16 text-gray-700"
                 viewBox="0 0 220 192" width="220" height="192" fill="none">
                <defs>
                    <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                        <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                    </pattern>
                </defs>
                <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
            </svg>
            <!-- @formatter:on -->
            <!-- Content -->
            <div class="z-10 absolute bottom-2 w-full max-w-2xl self-end">
                <feature-show-off-component></feature-show-off-component>
            </div>
        </div>
    </div>
    <br><br>

    <!-- Footer -->
    <div class="relative flex flex-0 justify-center w-full px-6 md:px-8 z-49 print:hidden">

            <div class="flex flex-col gap-2 sm:flex-row sm:gap-4 items-center h-fit py-4">
<!--                <span class="font-medium text-secondary min-w-fit">Smiles Manager &copy; {{currentYear}}</span>-->
                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['../smm-contact']">
                    {{'Contact' | transloco}}
                </a>

                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['../smm-prices']">
                    {{'Prices' | transloco}}
                </a>

                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['../agreements']"
                    [queryParams]="{type:'terms-and-conditions'}">
                    {{'Terms and conditions' | transloco}}
                </a>

                <a
                    class="text-primary-500 hover:underline text-xs sm:text-md"
                    [routerLink]="['../agreements']"
                    [queryParams]="{type:'confidentiality-policy'}">  {{'Confidentiality policy' | transloco}}
                </a>

            </div>

    </div>

</div>


<mat-menu #availableStages="matMenu">
    <div class="flex items-center flex-row text-center text-sm text-secondary text-center mx-4">
        {{'Please specify the reason for cancellation' | transloco}}
    </div>
    <mat-divider></mat-divider>
    <ng-container *ngFor="let status of relevantStatuses">
        <button mat-menu-item (click)="cancelAppointment(status)">
            {{relevantDecodedStatuses.get(status).reasonPatientView | transloco}}
        </button>
    </ng-container>
</mat-menu>


<!-- MISSING CODE -->
<ng-template #missingCode>
    <div class="flex flex-auto flex-col items-center justify-center">
        <mat-icon
            color="warn"
            class="icon-size-24"
            [svgIcon]="'heroicons_solid:exclamation-triangle'"></mat-icon>
        <div class="mt-6 text-2xl font-semibold tracking-tight text-secondary text-center">
            {{'Confirmation link is invalid!' | transloco}}
        </div>
        <span class="text-sm text-hint text-center">{{'Confirmation link seems incomplete' | transloco}}</span>
    </div>
</ng-template>

<!-- LOADING -->
<ng-template #loading>
    <div class="flex flex-auto flex-col items-center justify-center">
        <smm-loader [text]="'Looking for your appointment...' | transloco"></smm-loader>
    </div>
</ng-template>

<!-- LOADING -->
<ng-template #loaded>
    <ng-container *ngIf="confirmationDto">
        <!-- Title -->
        <div class=" text-3xl text-center w-full font-extrabold tracking-tight leading-tight">
            {{"Appointment confirmation" | transloco}}
            {{ confirmationDto.clinicName }}
        </div>

        <hr>
        <!-- Clinic Info -->
        <div class="mt-8 gap-1">
            <div class="flex items-center gap-4">
                <button mat-icon-button>
                    <mat-icon
                        class="icon-size-8 text-secondary"
                        [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
                </button>
                <div class="flex flex-col">
                    <div class="text-secondary">{{'Date' | transloco}}:</div>
                    <span>{{ startDate | date:'EEEE, dd MMMM yyyy':'':'ro-RO' | titlecase}}</span>
                </div>
            </div>
            <div class="flex items-center gap-4 mt-4">
                <button mat-icon-button>
                    <mat-icon
                        class="icon-size-8 text-secondary"
                        [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                </button>
                <div class="flex flex-col">
                    <div class="text-secondary">{{'Time:' | transloco}}</div>
                    <span>{{startDate | date:'HH:mm'}} - {{endDate | date:'HH:mm'}}</span>
                </div>
            </div>
            <div class="flex items-center gap-4 mt-4">
                <button mat-icon-button
                        [color]="getColorForDecodedStatus()">
                    <mat-icon
                        class="icon-size-8 text-secondary"
                        [svgIcon]="getIconForDecodedStatus()"></mat-icon>
                </button>
                <div class="flex flex-col">
                    <div class="text-secondary">{{'Current status:' | transloco}}</div>
                    <span>{{currentStatusDecoded.status | transloco | uppercase}}</span>
                </div>
            </div>

            <div class="flex items-center gap-4 mt-4">
                <button mat-icon-button>
                    <mat-icon
                        class="icon-size-8 text-secondary"
                        [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                </button>
                <div class="flex flex-col">
                    <div class="text-secondary">{{'Clinic address:' | transloco}}</div>
                    <span>{{confirmationDto.clinicAddress}}</span>
                </div>
            </div>

            <div class="flex items-center gap-4 mt-4">
                <a href="tel:{{confirmationDto?.clinicPhoneNumber}}">
                <button mat-icon-button>
                    <mat-icon
                        class="icon-size-7 text-secondary"
                        [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                </button>
                </a>
                <div class="flex flex-col">
                    <div class="text-secondary">{{'Clinic phone:' | transloco}}</div>
                    <span><a href="tel:{{confirmationDto?.clinicPhoneNumber}}"
                             class="bg-none hover:bg-primary-50 hover:dark:bg-primary-950 cursor-grab">
                            {{ confirmationDto?.clinicPhoneNumber }}</a>
                    </span>
                </div>
            </div>
        </div>

        <hr>

        <div class="grid grid-cols-1 sm:grid-cols-2 w-full gap-2">
            <button mat-flat-button color="warn" class="w-full"  [matMenuTriggerFor]="availableStages">{{'I will not make it' | transloco}}</button>
            <button mat-flat-button color="primary" class="w-full" (click)="confirmAppointment()">{{'I confirm my presence' | transloco}}</button>
        </div>

        <ng-container *ngTemplateOutlet="socialmedia"></ng-container>

    </ng-container>
</ng-template>

<!-- EXPIRED_INVALID_CODE -->
<ng-template #expired_invalid>
    <div class="flex flex-col items-center justify-center">
        <mat-icon
            color="warn"
            class="icon-size-24"
            [svgIcon]="'heroicons_solid:exclamation-triangle'"></mat-icon>
        <div class="text-2xl font-semibold tracking-tight text-secondary text-center">
            {{'Confirmation link has expired!' | transloco}}
        </div>
        <span class="text-sm text-hint text-center">{{'Confirmation link expired or invalid' | transloco}}</span>
    </div>
</ng-template>

<!-- CONFIRMED -->
<ng-template #confirmed>
    <div class="flex flex-col items-center justify-center">
        <mat-icon
            color="primary"
            class="icon-size-24"
            [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
        <div class="text-2xl font-semibold tracking-tight text-secondary text-center">
            {{'Thank you for confirming!' | transloco}}
        </div>
        <span class="text-md text-hint text-center">
            {{ 'Clinic informed successfully' | transloco: {clinicName: confirmationDto?.clinicName} }}
        </span>

        <div class="grid grid-cols-1 mt-8 gap-2 text-secondary">
            <div class="text-lg font-bold">{{'Here is what more you can do:' | transloco}}</div>
            <div class="text-sm text-hint -mt-2">{{'Press the icon buttons to perform an action' | transloco}}</div>
            <mat-divider class="w-full mb-2"></mat-divider>

            <div *ngIf="confirmationDto?.clinicPhoneNumber"
                class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <a href="tel:{{confirmationDto?.clinicPhoneNumber}}">
                <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                        mat-icon-button>
                    <mat-icon
                        class="icon-size-6 group-hover:text-primary"
                        [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                </button>
                </a>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Call clinic' | transloco }} ({{confirmationDto?.clinicPhoneNumber}})</div>
                    <div class="text-sm text-hint font-normal">{{ 'Get more information from clinic reception' | transloco }}</div>
                </div>
            </div>

            <div *ngIf="confirmationDto?.urlReviewGoogle"
                class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <a [href]="confirmationDto?.urlReviewGoogle">
                    <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                            mat-icon-button>
                        <mat-icon
                            class="icon-size-6 group-hover:text-primary"
                            [svgIcon]="'heroicons_outline:star'"></mat-icon>
                    </button>
                </a>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Add clinic review' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Provide feedback for clinic on Google reviews' | transloco }}</div>
                </div>
            </div>

            <div class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <a href="https://g.page/r/CcxSmV0h1unqEAE/review">
                    <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                            mat-icon-button>
                        <img src="/assets/images/logo/logo.svg" alt="it-service-review" class="icon-size-7">
                    </button>
                </a>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Add IT service review' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Provide feedback for IT services on Google reviews' | transloco }}</div>
                </div>
            </div>

            <div class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <a [href]="getGoogleCalendarLink()">
                <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                        mat-icon-button>
                    <mat-icon
                        class="icon-size-6 group-hover:text-primary"
                        [svgIcon]="'heroicons_solid:calendar'"></mat-icon>
                </button>
                </a>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Save to Google calendar' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Add event directly in your calendar' | transloco }}</div>
                </div>
            </div>

            <div class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                        mat-icon-button
                        (click)="downloadEventIcal()">
                    <mat-icon
                        class="icon-size-6 group-hover:text-primary"
                        [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
                </button>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Save to calendar iOS/Android/Windows' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Add event directly in your calendar' | transloco }}</div>
                </div>
            </div>

            <div *ngIf="confirmationDto?.urlGoogleMaps"
                class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <a [href]="confirmationDto?.urlGoogleMaps">
                    <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                            mat-icon-button>
                        <mat-icon
                            class="icon-size-6 group-hover:text-primary"
                            [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                    </button>
                </a>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Navigate to clinic' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Use Google maps to navigate to clinic' | transloco }}</div>
                </div>
            </div>

            <div class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                        mat-icon-button
                        (click)="closeWindow()">
                    <mat-icon
                        class="icon-size-6 group-hover:text-primary"
                        [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Close' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Close page' | transloco }}</div>
                </div>
            </div>
            <mat-divider class="w-full my-2"></mat-divider>
        </div>

        <ng-container *ngTemplateOutlet="socialmedia"></ng-container>

    </div>
</ng-template>

<!-- DECLINED -->
<ng-template #declined>
    <div class="flex flex-col items-center justify-center">
        <mat-icon
            color="primary"
            class="icon-size-24"
            [svgIcon]="'heroicons_solid:check'"></mat-icon>
        <div class="text-2xl font-semibold tracking-tight text-secondary text-center">
            {{'Your response has been sent!' | transloco}}
        </div>
        <span class="text-md text-hint text-center mt-8">
            {{'Sorry you cannot make it' | transloco: {clinicName: confirmationDto?.clinicName} }}

        <div class="grid grid-cols-1 mt-8 gap-2 text-secondary">
            <div class="text-lg font-bold">{{'Here is what more you can do:' | transloco}}</div>
            <div class="text-sm text-hint -mt-2">{{'Press the icon buttons to perform an action' | transloco}}</div>
            <mat-divider class="w-full mb-2"></mat-divider>

            <div *ngIf="confirmationDto?.clinicPhoneNumber"
                 class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <a href="tel:{{confirmationDto?.clinicPhoneNumber}}">
                <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                        mat-icon-button>
                    <mat-icon
                        class="icon-size-6 group-hover:text-primary"
                        [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                </button>
                </a>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Call clinic' | transloco }} ({{confirmationDto?.clinicPhoneNumber}})</div>
                    <div class="text-sm text-hint font-normal">{{ 'Get more information from clinic reception' | transloco }}</div>
                </div>
            </div>

            <div class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                        mat-icon-button
                        (click)="refresh()">
                    <mat-icon
                        class="icon-size-6 group-hover:text-primary"
                        [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
                </button>

                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Change response' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Go back and update your response' | transloco }}</div>
                </div>
            </div>

            <div class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <a href="https://g.page/r/CcxSmV0h1unqEAE/review">
                    <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                            mat-icon-button>
                        <img src="/assets/images/logo/logo.svg" alt="it-service-review" class="icon-size-7">
                    </button>
                </a>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Add IT service review' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Provide feedback for IT services on Google reviews' | transloco }}</div>
                </div>
            </div>

            <div class="flex flex-row gap-2 items-center w-full text-md font-bold">
                <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                        mat-icon-button
                        (click)="closeWindow()">
                    <mat-icon
                        class="icon-size-6 group-hover:text-primary"
                        [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
                <div class="w-full text-start flex flex-col gap-0 leading tight">
                    <div>{{ 'Close' | transloco }}</div>
                    <div class="text-sm text-hint font-normal">{{ 'Close page' | transloco }}</div>
                </div>
            </div>
            <mat-divider class="w-full my-2"></mat-divider>
        </div>

        <ng-container *ngTemplateOutlet="socialmedia"></ng-container>

        </span>
    </div>
</ng-template>

<!-- SOCIAL MEDIA -->
<ng-template #socialmedia>
<div *ngIf="
        (confirmationDto?.urlWebsite ||
        confirmationDto?.urlFacebook ||
        confirmationDto?.urlInstagram ||
        confirmationDto?.urlTikTok) && confirmationDto.clinicName"
     class="text-hint text-sm text-center w-full mt-8 -mb-3">
    {{'Follow on' | transloco: {clinicName: confirmationDto?.clinicName} }}
</div>

<div *ngIf="
        confirmationDto?.urlWebsite ||
        confirmationDto?.urlFacebook ||
        confirmationDto?.urlInstagram ||
        confirmationDto?.urlTikTok"
     class="flex flex-row w-full items-center justify-center gap-4 my-4">

    <a *ngIf="confirmationDto?.urlWebsite"
       [href]="confirmationDto?.urlWebsite" target="_blank">
        <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                mat-icon-button>
            <mat-icon
                class="icon-size-6 group-hover:text-primary"
                [svgIcon]="'feather:globe'"></mat-icon>
        </button>
    </a>

    <a *ngIf="confirmationDto?.urlFacebook"
       [href]="confirmationDto?.urlFacebook" target="_blank">
        <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                mat-icon-button>
            <mat-icon
                class="icon-size-6 group-hover:text-primary"
                [svgIcon]="'feather:facebook'"></mat-icon>
        </button>
    </a>

    <a *ngIf="confirmationDto?.urlInstagram"
       [href]="confirmationDto?.urlInstagram" target="_blank">
        <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                mat-icon-button>
            <mat-icon
                class="icon-size-6 group-hover:text-primary"
                [svgIcon]="'feather:instagram'"></mat-icon>
        </button>
    </a>

    <a *ngIf="confirmationDto?.urlTikTok"
       [href]="confirmationDto?.urlTikTok" target="_blank">
        <button class="bg-card shadow transition-transform hover:scale-[1.2]"
                mat-icon-button>
            <mat-icon
                class="icon-size-6 group-hover:text-primary"
                [svgIcon]="'feather:tiktok'"></mat-icon>
        </button>
    </a>
</div>
</ng-template>
